<template>
  <div class="select_dialog_embed">
    <div class="after_sales_apply_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--检测退回运单号是否已被其他售后单使用-->
        <div v-if="showType === 'checkOrderNum'" class="select_dialog_embed_box_content mt40 mb40 text_center fs16">
          <p>检测退回运单号已被其他售后单使用，是否继续操作？</p>
        </div>

        <!--删除明细-->
        <div v-if="showType === 'del'" class="select_dialog_embed_box_content mt40 mb40 text_center fs16">
          <p>是否删除所选货品明细？</p>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button v-if="showType === 'checkOrderNum'" class="btn_normal" @click="submitBtn()">继续</button>
          <button v-if="showType === 'del'" class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'after-sales-apply-embed-msg',
    /**
     *  title：  头部名
     *  showType:
     *  orderMsg: 订单信息
     * */
    props: ['title', 'showType', 'orderMsg'],
    components: {MsgDialog, LoadingDialog},
    data() {
      return {
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容' // 信息框内容
      }
    },
    methods: {
      // 提交售后申请
      saveRefundInfo() {
        this.$axios.post(this.Global.saveRefundInfo, this.orderMsg).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '提交售后申请成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'checkOrderNum') {
          this.saveRefundInfo();
        } else if (this.showType === 'del') {
          this.cancelBtn(true);
        } else {
          this.cancelBtn(false);
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {

    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .after_sales_apply_embed_msg {
    background-color: #fff;
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/after-sales-apply-embed-msg.vue